KMVP.individualDelivery = {
    bindAll: function(){
        $('.js-individual-delivery-select').bind('change', function (e) {
            KMVP.individualDelivery.storeDkgTelAvisData();
            window.location.href = $(this).data('controllerActionUrl') + $(e.target).val();
        });

        $('.js-order-datepicker-form').ajaxForm({
            success: function(res, status, xhr, $form) {
                var $orderEntryDatepicker = KMVP.individualDelivery.getOrderEntryDatepicker($form);
                var $orderDatepicker = KMVP.individualDelivery.getOrderDatepicker($form);
                var date = $orderDatepicker.datepicker('getDate');
                $orderEntryDatepicker.each(function(){
                    $(this).datepicker('setDate', date);
                });

                if(! KMVP.individualDelivery.isNoneOrAllEntriesHaveDeliveryDates($form)) {
                    $orderDatepicker.datepicker('setDate');
                }
                KMVP.individualDelivery.updateAllDeliveryHints();
            },
        });

        $('.js-quote-datepicker-form').ajaxForm({
            success: function(res, status, xhr, $form) {
                document.location.reload();
            },
        });

        $('.js-order-entry-datepicker-form').ajaxForm({
            success: function(res, status, xhr, $form) {
                KMVP.individualDelivery.updateDeliveryHint($form.closest('.js-order-entry'));
                if(! KMVP.individualDelivery.isNoneOrAllEntriesHaveDeliveryDates($form)) {
                    return;
                }

                var date = null;
                var isAllEntriesHaveSameDate = true;
                var $orderEntryDatepicker = KMVP.individualDelivery.getOrderEntryDatepicker($form);
                $orderEntryDatepicker.each(function(){
                    var $this = $(this);
                    if(date == null){
                        date = $this.datepicker('getDate');
                    } else if(date.getTime() != $this.datepicker('getDate').getTime()) {
                        isAllEntriesHaveSameDate = false;
                        return false;
                    }
                });
                var $orderDatepicker = KMVP.individualDelivery.getOrderDatepicker($form);
                if(isAllEntriesHaveSameDate){
                    $orderDatepicker.datepicker('setDate', date);
                } else {
                    $orderDatepicker.datepicker('setDate');
                }
            },
        });

        // disable datepicker (read-only) if this css class is found
        $('.js-read-only-datepicker').datepicker('disable');

		var $datepicker = $('.js-datepicker');
        if ($datepicker.data('readonly')) {
        	$datepicker.attr('readonly', true);
        }

        KMVP.individualDelivery.updateAllDeliveryHints();
        KMVP.individualDelivery.restoreTelAvisData();

    },
    updateAllDeliveryHints: function(){
        $('.js-order-entry').each(function(){
            KMVP.individualDelivery.updateDeliveryHint($(this));
        });
    },
    storeDkgTelAvisData: function () {
        if ($("#telephoneNotification").length) {
            localStorage.setItem("tel-avis-enabled", $("#telephoneNotification").is(':checked'));
            localStorage.setItem("tel-avis-person", $("#orderTelAvis_person").val());
            localStorage.setItem("tel-avis-phone", $("#orderTelAvis_phone").val());
            localStorage.setItem("tel-avis-time", $("#orderTelAvis_notificationTime").val());
            localStorage.setItem("tel-avis-crane", $("#order_crane").is(':checked'));
        }
    },
    restoreTelAvisData: function () {
        if (localStorage.getItem("tel-avis-enabled")) {
            $("#orderTelAvis_person").val(localStorage.getItem("tel-avis-person"));
            $("#orderTelAvis_phone").val(localStorage.getItem("tel-avis-phone"));
            $("#orderTelAvis_notificationTime").val(localStorage.getItem("tel-avis-time"));

            if (localStorage.getItem("tel-avis-enabled") === "true") {
                $("#telephoneNotification").click();
            }

            if (localStorage.getItem("tel-avis-crane") === "true") {
                $("#order_crane").click();
            }
        }

        localStorage.removeItem("tel-avis-enabled");
        localStorage.removeItem("tel-avis-person");
        localStorage.removeItem("tel-avis-phone");
        localStorage.removeItem("tel-avis-time");
        localStorage.removeItem("tel-avis-crane");
    },
    updateDeliveryHint: function($orderEntry){
        var $datepicker = $orderEntry.find('.js-datepicker');
        if($datepicker.length <= 0) {
            return;
        }
        var $deliveryHint = $orderEntry.find('.js-individual-delivery-hint');
        var date = new Date();
        if($datepicker.datepicker('getDate').getTime() > $datepicker.data('minDate')) {
            $deliveryHint.removeClass('hide')
        } else {
            $deliveryHint.addClass('hide')
        }
    },
    getAbstractOrderData: function($form) {
        if(!$form.data('$abstractOrderData')){
            $form.data('$abstractOrderData', $form.closest('.js-abstract-order-data'));
        }
        return $form.data('$abstractOrderData');
    },
    getOrderDatepicker: function($form) {
        var $abstractOrderData = KMVP.individualDelivery.getAbstractOrderData($form);
        if(!$abstractOrderData.data('$orderDatepicker')){
            $abstractOrderData.data('$orderDatepicker', $abstractOrderData.find('.js-order-datepicker-form .js-datepicker'));
        }
        return $abstractOrderData.data('$orderDatepicker');
    },
    getOrderEntryDatepicker: function($form) {
        var $abstractOrderData = KMVP.individualDelivery.getAbstractOrderData($form);
        if(!$abstractOrderData.data('$orderEntryDatepicker')){
            $abstractOrderData.data('$orderEntryDatepicker', $abstractOrderData.find('.js-order-entry-datepicker-form .js-datepicker'));
        }
        return $abstractOrderData.data('$orderEntryDatepicker');
    },
    getOrderEntryCount: function($abstractOrderData) {
        if(!$abstractOrderData.data('orderEntryCount')){
            $abstractOrderData.data('orderEntryCount', $abstractOrderData.find('.js-order-entry').length);
        }
        return $abstractOrderData.data('orderEntryCount');
    },
    isNoneOrAllEntriesHaveDeliveryDates: function($form) {
        if(!$form.data('isNoneOrAllEntriesHaveDeliveryDates')){
            var $abstractOrderData = KMVP.individualDelivery.getAbstractOrderData($form);
            var entryCount = KMVP.individualDelivery.getOrderEntryCount($abstractOrderData);
            var $orderEntryDatepicker = KMVP.individualDelivery.getOrderEntryDatepicker($form);
            $form.data('isNoneOrAllEntriesHaveDeliveryDates', $orderEntryDatepicker.length == 0 || entryCount == $orderEntryDatepicker.length);
        }
        return $form.data('isNoneOrAllEntriesHaveDeliveryDates');
    }
};

$(document).ready(function () {
    if ($('body').hasClass('page-singleStepCheckoutSummaryPage') || $('body').hasClass('page-quoteCartSingleStepCheckoutSummaryPage') || $('body').hasClass('page-quotes-details')) {
        KMVP.individualDelivery.bindAll();
    }
});
